export default function hasExtendedAllowedCharacters(value) {
  return new RegExp(/^[a-z0-9\s-s._,:;/\\\u00C0-\u017F]+$/i).test(value);
}
